var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconStrategy_1;
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { stateable } from '@slickdeals/durango/dist/javascript/decorators/stateable';
import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import { removeAllChildren } from '@slickdeals/durango/dist/javascript/utilities/dom';
import Icon from '../../components/icon';
import { Animations } from '../../utilities/animation';
/** The name of the module */
export const name = 'IconStrategy';
const defaultOptions = {
    activeIcon: null,
    defaultState: true,
    animation: null,
};
let IconStrategy = IconStrategy_1 = class IconStrategy {
    /**
       * Create an IconStrategy
       *
       * @param {Options} Object Data to initialize the component with
       */
    constructor(options) {
        this.element = options.element;
        this.inactiveIcon = Icon.createElement({ name: options.inactiveIconName });
        this.activeIcon = options.activeIconName ? Icon.createElement({ name: options.activeIconName }) : defaultOptions.activeIcon;
        this.defaultState = options.defaultState ?? defaultOptions.defaultState;
        this.animation = options.animation ?? defaultOptions.animation;
        this.shouldRemoveIcon = options.shouldRemoveIcon === true;
        this.init();
    }
    /**
       * Create a new instance of this object
       *
       * @param {Options} Object Data to initialize the component with
       *
       * @returns {IconStrategy}
       */
    static create(options) {
        return new IconStrategy_1(options);
    }
    /** Initialize the iconStrategy */
    init() {
        // Initialize the state
        const initState = {
            isActive: this.defaultState,
        };
        // Initialize the module's state
        this.initState(initState);
        // Add the initial icon
        this.populateIconContainer();
        // If there is an animation, apply it
        if (this.animation) {
            this.handleAnimation();
        }
    }
    /**
     * Perform any required cleanup to properly destroy the component
     */
    destroy() {
        if (!this.shouldRemoveIcon) {
            return;
        }
        removeAllChildren(this.element);
    }
    // Change the icon based on state
    toggleIcon() {
        this.setState({
            isActive: !this.getState().isActive,
        });
        // If there is an animation, toggle between states.
        // No need to re-populateIconContainer which is why that call is skipped
        if (this.animation) {
            this.handleAnimation();
            return;
        }
        // If no animation, toggle icon based on state
        this.populateIconContainer();
    }
    /** Handles the animation for the icon */
    handleAnimation() {
        const activeAnimation = classNameWithModifier(this.animation, 'active');
        // Checks to see if base animation class is set on element
        if (!this.element.classList.contains(this.animation)) {
            this.element.classList.add(...[Animations.Default, this.animation]);
        }
        this.element.classList.toggle(activeAnimation, this.getState().isActive);
    }
    /**
     * Populates the icon container (this.element) with an icon based on current isActiveState
     */
    populateIconContainer() {
        const emptyIconContainer = removeAllChildren(this.element);
        // If there is an animation, just apply the inactiveIcon because activeIcon doesn't exist
        if (this.animation) {
            emptyIconContainer.appendChild(this.inactiveIcon);
            return;
        }
        // Sets the default icon based state
        emptyIconContainer.appendChild(this.getState().isActive ? this.activeIcon : this.inactiveIcon);
    }
};
IconStrategy = IconStrategy_1 = __decorate([
    stateable(name),
    injectable(name)
], IconStrategy);
export default IconStrategy;
